import React from 'react'
import '../css/LeftPane.css'
import Select from 'react-select'
//import Select, { InputActionMeta } from 'react-select';
import { accessoryoptions } from '../collections/accessoryoptions'
import { armoptions } from '../collections/armoptions'
import { backgearoptions } from '../collections/backgearoptions'
import { backgroundoptions } from '../collections/backgroundoptions'
import { eyeoptions } from '../collections/eyeoptions'
import { headgearoptions } from '../collections/headgearoptions'
import { jewelryoptions } from '../collections/jewelryoptions'
import { mouthoptions } from '../collections/mouthoptions'
import { pantoptions } from '../collections/pantoptions'
import { shirtoptions } from '../collections/shirtoptions'
import { skinoptions } from '../collections/skinoptions'
import { skulloptions } from '../collections/skulloptions'
import { specialoptions } from '../collections/specialoptions'
import { tooloptions } from '../collections/tooloptions'
import { tribeoptions } from '../collections/tribeoptions'
import { vestoptions } from '../collections/vestoptions'




export default class LeftPane extends React.Component {

	render(){
		return(
			<div className="leftcontainer">
				<Select options={backgroundoptions} classNamePrefix="react-select" placeholder={<div>Background</div>} isClearable={true} onChange={(event) => this.props.selchange(event,'background')}/>
				<div className="break"></div>
				<Select options={backgearoptions} classNamePrefix="react-select" placeholder={<div>Back Gear</div>} isClearable={true} onChange={(event) => this.props.selchange(event,'backgear')}/>
				<div className="break"></div>
				<Select options={shirtoptions} classNamePrefix="react-select" placeholder={<div>Shirt</div>} isClearable={true} onChange={(event) => this.props.selchange(event,'shirt')}/>
				<div className="break"></div>
				<Select options={skinoptions} classNamePrefix="react-select" placeholder={<div>Skin</div>} isClearable={true} onChange={(event) => this.props.selchange(event,'skins')}/>
				<div className="break"></div>
				<Select options={pantoptions} classNamePrefix="react-select" placeholder={<div>Pants</div>} isClearable={true} onChange={(event) => this.props.selchange(event,'pants')}/>
				<div className="break"></div>
				<Select options={tooloptions} classNamePrefix="react-select" placeholder={<div>Tools</div>} isClearable={true} onChange={(event) => this.props.selchange(event,'tools')}/>
				<div className="break"></div>
				<Select options={jewelryoptions} classNamePrefix="react-select" placeholder={<div>Jewelry</div>} isClearable={true} onChange={(event) => this.props.selchange(event,'jewelry')}/>
				<div className="break"></div>
				<Select options={accessoryoptions} classNamePrefix="react-select" placeholder={<div>Accessories</div>} isClearable={true} onChange={(event) => this.props.selchange(event,'accessories')}/>
				<div className="break"></div>
				<Select options={mouthoptions} classNamePrefix="react-select" placeholder={<div>Mouth</div>} isClearable={true} onChange={(event) => this.props.selchange(event,'mouth')}/>
				<div className="break"></div>
				<Select options={eyeoptions} classNamePrefix="react-select" placeholder={<div>Eyes</div>} isClearable={true} onChange={(event) => this.props.selchange(event,'eyes')}/>
				<div className="break"></div>
				<Select options={headgearoptions} classNamePrefix="react-select" placeholder={<div>Head Gear</div>} isClearable={true} onChange={(event) => this.props.selchange(event,'headgear')}/>
				<div className="break"></div>
				<Select options={tribeoptions} classNamePrefix="react-select" placeholder={<div>Tribe</div>} isClearable={true} onChange={(event) => this.props.selchange(event,'tribe')}/>
				<div className="break"></div>
				<Select options={vestoptions} classNamePrefix="react-select" placeholder={<div>Vest</div>} isClearable={true} onChange={(event) => this.props.selchange(event,'vest')}/>
				<div className="break"></div>
				<Select options={armoptions} classNamePrefix="react-select" placeholder={<div>Arm</div>} isClearable={true} onChange={(event) => this.props.selchange(event,'arm')}/>
				<div className="break"></div>
				<Select options={skulloptions} classNamePrefix="react-select" placeholder={<div>Skull</div>} isClearable={true} onChange={(event) => this.props.selchange(event,'skull')}/>
				<div className="break"></div>
				<Select options={specialoptions} classNamePrefix="react-select" placeholder={<div>Special</div>} isClearable={true} onChange={(event) => this.props.selchange(event,'special')}/>
			</div>
		);
	}
}
